<template>
  <div class="card card--white">
    <div class="card--container">
      <v-alert type="error" :value="displayError">
        {{ displayError }}
      </v-alert>
      <h-input type="text" required label="Title of the Course" v-model="course.title"/>
      <h-input type="text" label="Description of the Course" v-model="course.description" required/>
      <h-file label="Course Image" @upload="f => course.background_image = f" :base64="true" />
      <v-list v-if="course.modules.length > 0">
        <v-list-tile v-for="module in course.modules" :key="module">
          <v-list-tile-title>{{ module.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>

      <div class="small-top">
        <h-btn color="primary" @click="saveCourse">Save</h-btn>
        <h-btn :flat='true' @click="$router.go(-1)">Cancel</h-btn>
      </div>
    </div>
  </div>
</template>

<script>
import User from "@/services/api/authUser";
import dataStore from "@/services/api/store";
const COURSE_STORE = "CoachCourses";

export default {
  props: ["course"],
  data() {
    return {
      displayError: "",
      userId: User.id
    };
  },
  methods: {
    saveCourse() {
      if (!this.course.title) {
        this.displayError = "Title is required";
        return;
      }
      if (!this.course.description) {
        this.displayError = "Description is required";
        return;
      }
      if (this.course.hasOwnProperty("id")) {
        dataStore
          .update(COURSE_STORE, this.course.id, this.course)
          .then(course => {
            this.$router.push({
              name: "CoachCourseDetail",
              params: { id: course.id }
            });
          });
      } else {
        dataStore.create(COURSE_STORE, this.course).then(course => {
          this.$router.push({
            name: "CoachCourseDetail",
            params: { id: course.id }
          });
        });
      }
    }
  }
};
</script>
